import Divider from "@material-ui/core/Divider";
import Grid from "@material-ui/core/Grid";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Typography from "@material-ui/core/Typography";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
import { useState } from "react";
import { useHistory } from "react-router-dom";
import { AccountDetailsMenuList } from "@constants";
import "./css/AccountDetailsMenu.scss";
import { Modal } from "@common/Modal/Modal";
import { useTranslation } from "react-i18next";
import { fixUrlLanguage } from "@utils/changeLanguage";

interface IParams {
    hasActiveOfferDetails: boolean;
    isInCollection: boolean | undefined;
}

interface IOfferMenuItem {
    externalUrl?: string;
    isBlockedIfNoService: boolean;
    title: string;
    url?: string;
    preventIfInCollection: boolean;
}

export const AccountDetailsMenu = (props: IParams) => {
    const { hasActiveOfferDetails, isInCollection } = props;
    const { t } = useTranslation(["accountDetails", "glossary"]);
    const [isActionAvailable, setIsActionAvailable] = useState(true);
    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
    const history = useHistory();

    const linkOnClickAction = (menuItem: IOfferMenuItem) => {
        if (isInCollection && menuItem.preventIfInCollection) {
            setIsModalOpen(true);
        } else if (!hasActiveOfferDetails && menuItem.isBlockedIfNoService) {
            setIsActionAvailable(false);
        } else {
            setIsActionAvailable(true);
            if (menuItem.externalUrl) {
                window.location.href = menuItem.externalUrl;
            } else if (menuItem.url) {
                history.push(fixUrlLanguage(menuItem.url));
            }
        }
    };

    return (
        <div className="offer-menu">
            {!isActionAvailable && (
                <Grid container spacing={1} wrap="wrap">
                    <Grid item sm={6} xs={12}>
                        <Typography>This action is unavailable until your service is activated.</Typography>
                    </Grid>
                </Grid>
            )}
            <List component="nav">
                <Grid container spacing={1} wrap="wrap">
                    {AccountDetailsMenuList.map((menuItem: IOfferMenuItem) => (
                        <Grid item key={menuItem.title} sm={6} xs={12}>
                            <ListItem button onClick={() => linkOnClickAction(menuItem)}>
                                <ListItemText color="primary" primary={menuItem.title} />
                                <KeyboardArrowRight />
                            </ListItem>
                            <Divider light />
                        </Grid>
                    ))}
                </Grid>
            </List>
            <Modal
                close={() => setIsModalOpen(false)}
                confirm={() => setIsModalOpen(false)}
                confirmLabel={t("glossary:close")}
                content={t("accountDetails:isInCollectionError")}
                isModalOpen={isModalOpen}
                title={t("glossary:error")}
            />
        </div>
    );
};
